import React from 'react';
import "./selectModel.less"
import "./cardStyle.less"
import { makeModelList, computeCardHeight, makeCard } from "./utils"
import makeCheckModal from "../components/checkModal"

function SelectModel(props) {
    console.log("===select model props==", props);

    const { customProps: { template, fields }, selectModal, defaultColor, I18N } = props

    const modelList = makeModelList(template, defaultColor);

    console.log("modelList", modelList);

    const selectModalHandle = modelItem => {
        selectModal(modelItem.model, {
            backgroundcolor: modelItem.backgroundcolor,
            bordercolor: modelItem.bordercolor,
            topbordercolor: modelItem.topbordercolor,
        })
    }

    const showFieldsHandle = () => {
        makeCheckModal({
            title: I18N("modal.title"),
            colNameStr: I18N("modal.fieldName"),
            checkedStr: I18N("modal.selected"),
            clearStr: I18N("modal.clear"),
            sureStr: I18N("op.sure"),
            cancelStr: I18N("op.cancel"),
            checkList: fields,
            defaultValue: [],
        }).then(res => {
            // console.log("确定", res);
            indiviCard(res.fields)
        }).catch(res => {
            // console.log("取消", res);
        })
    }

    const indiviCard = fields => {
        const model = fields.map((field, i) => {
            return {
                i: field.id + "",
                x: 0,
                y: 26 * i,
                w: 180,
                h: 26,
                aftercontent: "",
                align: 2,
                beforecontent: "",
                bold: false,
                fontSize: "14",
                name: field.name,
                showInfo: field.sampledate ?? "",
            }
        })

        selectModal(model)
    }

    return (
        <div className="select-wrapper">
            <div className="sub-title">{I18N("select.title")}</div>
            <div className="cardmodel-wrapper">
                {
                    modelList.map(modelItem => {
                        return (
                            <div className="cardmodel-box" key={modelItem.id}>
                                <div onClick={() => { selectModalHandle(modelItem) }}
                                    className="model"
                                    style={{
                                        height: computeCardHeight(modelItem.model),
                                        background: modelItem.backgroundcolor,
                                        border: "1px solid " + modelItem.bordercolor
                                    }}
                                >
                                    {
                                        modelItem.topbordercolor && (
                                            <div className="topBar" style={{ background: modelItem.topbordercolor }}></div>
                                        )
                                    }
                                    {
                                        modelItem.model.map(fields => makeCard(fields))
                                    }
                                </div>
                            </div>
                        )
                    })
                }
                {
                    fields.length > 0 && (
                        <div className="cardmodel-btn-box">
                            <div className="model-btn" onClick={showFieldsHandle}>
                                <i data-v-37a61f14="" className="kdfont kdfont-tianjia"></i>
                                <span>{I18N("select.indivi")}</span>
                            </div>
                        </div>
                    )
                }
                {
                    fields.length === 0 && (
                        <span style={{ color: "#999" }}>{I18N("select.tips")}</span>
                    )
                }
            </div>
        </div>
    );
}

export default SelectModel;